import Vue from 'vue';

export class Fabricante {

    /**
     *
     * @returns {Promise}
     */
    static all() {
        return new Promise((ok, fail) => {
            Vue.http.get('fabricantes')
                .then((res) => ok(res.data))
                .catch((err) => fail(err))
        })
    }

}